const { axios } =
  await import(`./index.js?v=${Date.now()}`);
const { debounce } =
  await import(`./debounce.js?v=${Date.now()}`);
import "./_commonjsHelpers.js";
import "./recommended-products.js";
class SearchModal extends HTMLElement {
  constructor() {
    var _a;
    super();
    const searchTrigger = document.querySelector(".search-trigger");
    const form = this.querySelector(".form");
    const header = document.querySelector(".header");
    const input = this.querySelector(".form__input");
    const submit = this.querySelector(".form__submit");
    const predictiveSearchResultsSectionId = (_a = document.querySelector(".predictive-search-results")) == null ? void 0 : _a.getAttribute("data-section-id");
    const searchHolder = document.querySelector(".predictive-search-modal");
    const mobileInput = document.querySelector(
      '.mobile-navigation form input[type="text"]'
    );
    const mobileSearch = document.querySelector(
      ".mobile-navigation form"
    );
    const mobileNavigation = document.querySelector(".mobile-navigation");
    const mobileSearchInput = document.querySelector("#input-search-mobile");
    this.classList.add("search-hidden");
    const syncSearchInputs = (e) => {
      const value = e.target.value;
      if (e.target.id === "input-search-mobile") {
        input.value = value;
        input.dispatchEvent(new Event("input", { bubbles: true }));
      } else {
        mobileSearchInput.value = value;
      }
    };
    input == null ? void 0 : input.addEventListener("input", syncSearchInputs);
    mobileSearchInput == null ? void 0 : mobileSearchInput.addEventListener("input", syncSearchInputs);
    searchHolder.style.transform = "translateY(32px)";
    const handleCloseSuggestionListener = () => {
      const suggestBackground = document.querySelector(
        ".js-suggestion-background"
      );
      const suggestionsHolder = document.querySelector(".suggestions-holder");
      suggestBackground.addEventListener("mouseover", () => {
        suggestionsHolder == null ? void 0 : suggestionsHolder.classList.remove("suggestions-holder--active");
        suggestBackground == null ? void 0 : suggestBackground.classList.remove("background-curtain--active");
        hideSearch();
      });
    };
    const showEmptySearch = () => {
      const backgroundCurtain = document.querySelector(".background-curtain");
      const popularResults = document.querySelector(".popular-results");
      backgroundCurtain == null ? void 0 : backgroundCurtain.classList.add("background-curtain--active");
      popularResults == null ? void 0 : popularResults.classList.add("js-active");
    };
    const handleBackdrop = () => {
      const backdrop = document.querySelector(
        ".predictive-search-results .js-base-background"
      );
      const predictiveSearch = document.querySelector(".search-results-holder");
      backdrop.addEventListener("mouseover", (e) => {
        predictiveSearch.remove();
        backdrop.remove();
      });
    };
    const hideSearch = () => {
      const backdrop = document.querySelector(
        ".predictive-search-results .js-base-background"
      );
      const predictiveSearch = document.querySelector(".search-results-holder");
      predictiveSearch == null ? void 0 : predictiveSearch.remove();
      backdrop == null ? void 0 : backdrop.remove();
      this.classList.add("search-hidden");
    };
    if (searchTrigger) {
      searchTrigger.addEventListener("click", () => {
        const mobileMenuTrigger = document.querySelector("#js-trigger-mobile-menu");
        if (window.innerWidth < 1024) {
          if (!mobileNavigation.classList.contains("js-mobile-navigation-open")) {
            mobileNavigation.classList.add("js-mobile-navigation-open");
            mobileMenuTrigger == null ? void 0 : mobileMenuTrigger.classList.add("is-open");
            setTimeout(() => {
              mobileInput == null ? void 0 : mobileInput.focus();
              mobileSearch.style.display = "flex";
            }, 100);
          } else {
            mobileInput == null ? void 0 : mobileInput.focus();
            mobileSearch.style.display = "flex";
          }
        } else {
          form.classList.add("form--active");
          header.classList.add("js-active");
          this.classList.remove("search-hidden");
          if (form.classList.contains("form--active")) {
            setTimeout(() => {
              input == null ? void 0 : input.focus();
            }, 100);
          }
        }
      });
    }
    const renderSections = (dom, sectionsArray) => {
      sectionsArray.forEach((section) => {
        const source = dom.querySelector(section);
        const destination = document.querySelector(section);
        destination.innerHTML = source.innerHTML;
      });
    };
    const handleSearchInput = debounce((searchTerm) => {
      const sectionsArray = [".predictive-search-results-holder"];
      const searchResults = document.querySelector(".search-results-holder");
      const suggestionsHolder = document.querySelector(".suggestions-holder");
      const url = `/search/suggest?q=${searchTerm}&resources[type]=product,collection,article&section_id=${predictiveSearchResultsSectionId}`;
      if (searchTerm !== "") {
        if (searchResults) {
          searchResults.querySelectorAll("*").forEach((el) => {
            el.style.opacity = "0.8";
            el.style.transition = "opacity .35s ease";
          });
        }
        if (suggestionsHolder) {
          suggestionsHolder.querySelectorAll("*").forEach((el) => {
            el.style.opacity = "0.8";
            el.style.transition = "opacity .35s ease";
          });
        }
        axios.get(url).then((response) => {
          const parser = new DOMParser();
          const dom = parser.parseFromString(response.data, "text/html");
          renderSections(dom, sectionsArray);
          handleBackdrop();
        }).catch((error) => {
          throw error;
        }).finally(() => {
          if (searchResults) {
            searchResults.style.opacity = "1";
          }
        });
      } else {
        hideSearch();
        if (suggestionsHolder) {
          suggestionsHolder.style.opacity = "1";
          suggestionsHolder.querySelectorAll("*").forEach((el) => {
            el.style.opacity = "1";
          });
        }
      }
    }, 300);
    if (input) {
      input.addEventListener("input", (e) => {
        input.value !== "" ? submit.classList.add("js-active") : submit.classList.remove("js-active");
        handleSearchInput(e.target.value);
        showEmptySearch();
        if (input.value === "") {
          hideSearch();
        }
      });
      input.addEventListener("focus", () => {
        const suggestionsHolder = document.querySelector(".suggestions-holder");
        const suggestionBackground = document.querySelector(
          ".js-suggestion-background"
        );
        suggestionsHolder == null ? void 0 : suggestionsHolder.classList.add("suggestions-holder--active");
        suggestionBackground == null ? void 0 : suggestionBackground.classList.add("background-curtain--active");
        handleCloseSuggestionListener();
      });
      mobileInput.addEventListener("focus", () => {
        const suggestionsHolder = document.querySelector(".suggestions-holder");
        const suggestionBackground = document.querySelector(
          ".js-suggestion-background"
        );
        suggestionsHolder == null ? void 0 : suggestionsHolder.classList.add("suggestions-holder--active");
        suggestionBackground == null ? void 0 : suggestionBackground.classList.add("background-curtain--active");
        handleCloseSuggestionListener();
      });
    }
  }
}
if (customElements.get("search-modal") === void 0) {
  customElements.define("search-modal", SearchModal);
}
